// class CartRecommendations extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
//   }

//   handleIntersection(entries, observer) {
//     if (!entries[0].isIntersecting) return;
//     observer.unobserve(this);
    
//     fetch(this.dataset.url)
//       .then(response => response.text())
//       .then(text => {
        
//         const html = document.createElement('div');
//         html.innerHTML = text;
//         const recommendations = html.querySelector('cart-recommendations');
//         if (recommendations && recommendations.innerHTML.trim().length) {
//           this.innerHTML = recommendations.innerHTML;
//         }
//       })
//       .catch(e => {
//         console.error(e);
//       });
//   }
// }
// customElements.define('cart-recommendations', CartRecommendations);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    document.addEventListener('cart:changed', this.fetchRecommendations.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('cart:changed', this.fetchRecommendations.bind(this));
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    this.fetchRecommendations();
  }

  fetchRecommendations() {
    console.log('Fetching recommendations...');
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        this.innerHTML = recommendations.innerHTML;
        // if (recommendations && recommendations.innerHTML.trim().length) {
        //   this.innerHTML = recommendations.innerHTML;
        // }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);